export default "__VITE_ASSET__41tiGDtD__"